module.exports = "<div class=\"modal-body\">\r\n        <ng-content></ng-content>   \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/shared/modeldialog/template/modal-body.Template.html
// module id = 603
// module chunks = 3